// extracted by mini-css-extract-plugin
module.exports = {"label":"checkBox_label__3UqBE","text":"checkBox_text__20O4q","col":"checkBox_col__icgMo","input":"checkBox_input__17gIS","empty":"checkBox_empty__2b1hZ"};